import { TableHeading } from "../../../../components/common/table/TableDesign";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

/*----------------------------*/
/* SignOff Task Screen */
/*----------------------------*/
export const signOffTaskHeading: any[] = [
  { label: "Day", width: 200, colspan: 3 },
  { label: "Crew", width: 40 },
  { label: "Cust", width: 40 },
  { label: "Members", width: 130 },
  { label: "Status", width: 80 },
  { label: "Vehicle", width: 100 },
  { label: "Team Leader", width: 80 },
  { label: "Wages", width: 70 },
  { label: "Overtime", width: 70 },
  { label: "Extras", width: 70 },
  { label: "Review", width: 70 },
  { label: "Driving", width: 70 },
  { label: "Speed", width: 70 },
  { label: "Style", width: 70 },
  { label: "Worker Notes", width: 160 },
  { label: "Task", width: 90 },
  { label: "Task Detail", width: 160 },
    { label: "Transport Notes (Internal)", width: 150 },
];

export const signOffTaskFields = [
  // {
  //   id: "typeName",
  //   type: "staticText",
  // },
  {
    id: "typeName",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "provisionalDate",
    type: "staticText",
    width: "120px",
  },
  {
    id: "price",
    placeholder: "Charge",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "driverQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "porterQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "packerQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "wageCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vehicleTypeId",
    placeholder: "",
    type: "select",
    width: "100px",
  },
  {
    id: "vehicleQty",
    placeholder: "Qty",
    type: "text",
    width: "35px",
    inputProps: {
      maxLength: 2,
    },
    // disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "fuelCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadCostHeading: TableHeading[] = [
  { label: "Drivers" },
  { label: "Porters", align: "left" },
  { label: "Packers", align: "left" },
  { label: "Wages", align: "center" },
  { label: "Vehicles", align: "center" },
  { label: "", align: "center" },
  { label: "Fuel", align: "center" },
];

export const leadCostFields = [
  {
    id: "driverQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "porterQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "packerQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "wageCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vehicleTypeId",
    placeholder: "",
    type: "select",
    width: "100px",
  },
  {
    id: "vehicleQty",
    placeholder: "Qty",
    type: "text",
    width: "35px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "fuelCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadMaterialsHeading: TableHeading[] = [
  { label: "Materials" },
  { label: "Surveyed Qty", align: "left" },
  { label: "Charge Qty", align: "left" },
  { label: "Rate", align: "center" },
  { label: "Total", align: "center" },
  { label: "Volume", align: "center" },
  { label: "Cost", align: "center" },
];

export const leadMaterialsFields = [
  {
    id: "name",
    type: "staticText",
  },
  {
    id: "surveyedQty",
    placeHolder: "",
    type: "text",
    width: "100px",
    disabled: true,
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "chargeQty",
    placeHolder: "",
    type: "text",
    width: "100px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "total",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "volume",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "cost",
    placeHolder: "",
    type: "text",
    width: "70px",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadGenInfoHeading: TableHeading[] = [
  { label: "General Information" },
  { label: "", align: "left" },
];

export const leadGenInfoFields = [
  {
    id: "generalInformation",
    type: "staticText",
  },
  {
    id: "price",
    placeHolder: "",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadGenInoList = [
  { generalInformation: "Driver wage", price: "", id: "driverWage" },
  { generalInformation: "Porter wage", price: "", id: "porterWage" },
  { generalInformation: "Packer wage", price: "", id: "packerWage" },
  // { generalInformation: "Contents Value", price: "", id: "contentsValue" },
];

export const leadAncillariesHeading: TableHeading[] = [
  { label: "Ancillaries" },
  { label: "", align: "left" },
  { label: "Charageable" },
];

export const leadAncillariesFields = [
  // {
  //   id: "name",
  //   type: "staticText",
  // },
  {
    id: "name",
    placeHolder: "",
    type: "text",
    width: "60px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "charge",
    placeHolder: "",
    type: "text",
    width: "60px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "isChargeable",
    placeHolder: "",
    type: "checkbox",
    width: "40px",
  },
];

export const leadAncillariesList = [
  { ancillaries: "Tolls", price: "", charageable: false },
  { ancillaries: "Ferry charges", price: "", charageable: false },
  { ancillaries: "", price: "", charageable: false },
];

export const leadQuoteSubcontractorHeading: TableHeading[] = [
  { label: "Subcontractor" },
  { label: "Name", align: "left" },
  { label: "Charge", align: "left" },
];

export const leadQuoteSubcontractorFields = [
  {
    id: "subContractorId",
    placeHolder: "",
    type: "select",
    width: "200px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "name",
    placeHolder: "",
    type: "text",
    width: "180px",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "chargeAmount",
    placeHolder: "",
    type: "text",
    width: "100px",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
];

export const leadEstimateFinalFields = [
  {
    label: "Content :",
    type: "title",
    md: 1.5,
  },
  {
    id: "contentValue",
    label: {
      quotation: "Content Value",
      estimate: "Content Value",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    // disabled: true,
    inSingleGridForm: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    label: "",
    type: "title",
    md: 8.5,
  },
  {
    label: "Amount :",
    type: "title",
    md: 1.5,
  },
  {
    id: "quoteTotal",
    label: {
      quotation: "Quote Total",
      estimate: "Total",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    inSingleGridForm: true,
    disabled: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },

  {
    id: "costTotal",
    label: {
      quotation: "Total Cost",
      estimate: "Total Cost",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    inSingleGridForm: true,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    label: "",
    type: "title",
    md: 6.5,
  },
  {
    label: "Expiry :",
    type: "title",
    md: 1.5,
  },
  {
    id: "quoteExpiresOn",
    label: {
      quotation: "Quote Expires On",
      estimate: "Estimate Expires On",
    },
    placeHolder: "",
    type: "date",
    disablePast: true,
    inSingleGridForm: true,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "profit",
    label: {
      quotation: "Profit",
      estimate: "Profit",
    },
    placeHolder: "",
    type: "text",
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    inSingleGridForm: true,
    valueFormat: "price",
    // prefixIcon: "£",
    patternAllowed: patternConstant?.PERCENTAGE,
  },
];

export const leadEstimateInsuranceGeneralFields = [
  {
    id: "insurancePercentage",
    label: "Insurance (%)",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    patternAllowed: patternConstant?.PERCENTAGE,
  },
];
export const leadEstimateInsuranceFields = [
  {
    id: "insuranceAmount",
    label: "Insurance Amount",
    placeHolder: "",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    disabled: false,
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "insuranceType",
    label: "Insurance Type",
    placeHolder: "",
    type: "select",
    options: [
      "Move Price",
      "Contents",
      "Pack Price",
      "In to store",
      "From store",
      "Fixed",
      "Bronze Ext Liability",
      "Silver Ext Liability",
      "Gold Ext Liability",
    ],
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const leadEstimateNoteFields = [
  {
    id: "notes",
    label: "Notes",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const leadQuoteNoteFields = [
  {
    id: "notes",
    label: "Notes",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "transportnote",
    label: "Transport Notes",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "quotenote",
    label: "Quote Notes",
    placeHolder: "",
    type: "textarea",
    firstColmd: 1.5,
    md: 10.5,
    // minRows: 2,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];
export const leadLogsFields = [
  {
    id: "action",
    title: "Input",
    placeHolder: "Insert text",
    type: "text",
    md: 5,
    isMandatory: true,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "action_type",
    title: "Stage",
    placeHolder: "Select",
    type: "select",
    options: ["NEW LEAD", "ESTIMATES", "SURVEY", "QUOTE", "CONFIRMED"],
    md: 4,
  },
];

export const LEAD_LOG_STARTER_FIELD = [
  {
    id: "action",
    title: "Input",
    placeHolder: "Insert text",
    type: "text",
    md: 5,
    isMandatory: true,
    inputProps: {
      maxLength: 150,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "action_type",
    title: "Stage",
    placeHolder: "Select",
    type: "select",
    options: [
      "NEW LEAD",
      "ESTIMATES",
      "SURVEY",
      "QUOTE",
      "CONFIRMED",
      "ARCHIVED",
    ],
    md: 2.5,
  },
  {
    id: "status_change_reason",
    title: "Reason",
    placeHolder: "Select",
    type: "select",
    options: [],
    md: 2.5,
  },
];
